export const SHOW_DELIVERY_SLOT_CARDS = {
    THRESHOLD: 8,
    MINIMUM_CARDS: 6,
};

export const TEXTS = {
    VIEW_MORE_SLOTS: "View more slots",
};
